module.exports = __webpack_public_path__ + "static/SourceSansPro-Regular-61cda204e4149137a75b6faad155dcc4.woff2";